/* DRESSFRESH accessibility helpers.
   1. Space activates links that behave as buttons (Enter already works natively).
   2. Pause control for looping video, looping diagrams and the rotating announcement bar.
      Everything always starts playing with no click, for every visitor. Pausing lasts for the current page only.
   3. Keeps looping videos playing: starts them in view, retries when the browser delays or blocks autoplay
      (including on the first touch, for iPhones in Low Power Mode). */
(function () {
  var root = document.documentElement;
  var strings = window.accessibilityStrings || {};
  var labelPause = strings.pauseMotion || 'Pause motion';
  var labelPlay = strings.playMotion || 'Play motion';

  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' || e.defaultPrevented) return;
    var t = e.target;
    if (!(t instanceof Element) || !t.matches('a[role="button"], a[href*="#drawer"], a[href*="#modal"], a[data-df-nl-open]')) return;
    if (t.hasAttribute('data-df-sheet')) return; /* handled by df-fx-sci-chapter.js */
    e.preventDefault();
    t.click();
  });

  /* an older version remembered the paused state between pages; clear it so nobody stays paused */
  try { localStorage.removeItem('df-motion'); } catch (err) { /* storage unavailable */ }

  var off = false;

  function loopingVideos() {
    return Array.prototype.filter.call(document.querySelectorAll('video'), function (v) {
      return !v.controls && (v.loop || v.hasAttribute('autoplay') || v.hasAttribute('data-df-bg'));
    });
  }

  function ready(v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
  }

  function inView(v) {
    var r = v.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function start(v) {
    if (off || !inView(v)) return;
    ready(v);
    if (v.preload === 'none') v.preload = 'auto';
    if (v.networkState === 3) v.load(); /* nothing loaded yet because of a deferred source */
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function startAll() { loopingVideos().forEach(start); }

  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var watcher = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) start(e.target); });
  }, { rootMargin: '120px 0px' }) : null;

  function watch() {
    loopingVideos().forEach(function (v) {
      if (seen && seen.has(v)) return;
      if (seen) seen.add(v);
      ready(v);
      if (watcher) watcher.observe(v);
      ['loadedmetadata', 'canplay'].forEach(function (name) { v.addEventListener(name, function () { start(v); }); });
      v.addEventListener('ended', function () { v.currentTime = 0; start(v); });
    });
  }

  function apply() {
    root.classList.toggle('df-motion-off', off);
    loopingVideos().forEach(function (v) {
      if (off) { v.pause(); return; }
      start(v);
    });
    document.querySelectorAll('gridy-slider[data-autoplay="true"]').forEach(function (g) {
      if (!g.config || !g.config.autoplay) return;
      if (off) { if (g.clearAutoplayTimer) g.clearAutoplayTimer(); }
      else if (g.autoplayGridy) g.autoplayGridy();
    });
    document.querySelectorAll('.df-motion').forEach(function (b) {
      b.setAttribute('aria-label', off ? labelPlay : labelPause);
    });
  }

  /* Other scripts restart videos when they scroll into view; a paused state wins over them. */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (off && v instanceof HTMLVideoElement && !v.controls && (v.loop || v.hasAttribute('autoplay') || v.hasAttribute('data-df-bg'))) v.pause();
  }, true);

  function control(kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'df-motion df-motion--' + kind;
    b.setAttribute('aria-label', off ? labelPlay : labelPause);
    b.innerHTML = '<svg class="df-motion__pause" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><rect x="1.5" y="0.5" width="2.4" height="9"/><rect x="6.1" y="0.5" width="2.4" height="9"/></svg><svg class="df-motion__play" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M2 0.5v9l7-4.5z"/></svg>';
    b.addEventListener('click', function () { off = !off; apply(); });
    return b;
  }

  function init() {
    /* videos: one control beside each looping video, unless the section has its own play/pause button */
    loopingVideos().forEach(function (v) {
      var host = v.parentElement;
      if (!host || v.closest('dialog, .modal, [data-df-sheet-root]')) return;
      var section = v.closest('section, .shopify-section');
      if (section && section.querySelector('.cx__play')) return;
      if (v.getAttribute('aria-hidden') === 'true') {
        /* background video: the control must not sit inside a hidden wrapper */
        while (host.closest('[aria-hidden="true"]') && host.parentElement) host = host.parentElement;
      }
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(control('overlay'));
    });

    /* looping diagrams on The Science: one control per section, in the caption row or the section heading */
    document.querySelectorAll('.df.df-sci').forEach(function (sec) {
      if (!sec.querySelector('svg [class*="a-"], svg[class*="a-"]')) return;
      var slot = sec.querySelector('.dgm__cap') || sec.querySelector('.shead .eyebrow');
      if (!slot || slot.closest('[aria-hidden="true"], button, a, summary')) return;
      if (slot.classList.contains('eyebrow')) slot = slot.parentElement;
      slot.appendChild(control('inline'));
    });

    /* announcement bar */
    document.querySelectorAll('.announcements-bar').forEach(function (bar) {
      var g = bar.querySelector('gridy-slider[data-autoplay="true"]');
      if (!g || bar.querySelectorAll('.announcement').length < 2) return;
      bar.appendChild(control('bar'));
    });

    watch();
    apply();

    /* retries: pages restored from history, returning to the tab, and the first touch or scroll */
    window.addEventListener('pageshow', startAll);
    window.addEventListener('load', startAll);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) startAll(); });
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (name) {
      window.addEventListener(name, startAll, { passive: true, capture: true });
    });
    /* videos added later (theme sections, responsive sources) */
    if ('MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return; queued = true;
        setTimeout(function () { queued = false; watch(); startAll(); }, 300);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
